<div class="media">
    <video class="media-object">
        <source [src]="video" type="video/mp4">
    </video>
</div>
